// THIS FILE WILL BE USED AGAINST THE PREVIEW COMPONENT
// TODO: Set up a script to generate this file for public directory

// REMOVE `export` WHEN COPYING TO PUBLIC DIRECTORY
export function toggleMobileMenu() {
    if (document?.getElementById("mobileMenu") !== null) {
      if (document.getElementById("mobileMenu").style.display === "none") {
        document.getElementById("mobileMenu").style.display = "flex";
        document.getElementById("mobileButtonClose").style.display = "block";
        document.getElementById("mobileButtonHamburger").style.display = "none";
      } else {
        document.getElementById("mobileMenu").style.display = "none";
        document.getElementById("mobileButtonClose").style.display = "none";
        document.getElementById("mobileButtonHamburger").style.display =
          "block";
      }
    }
  }

  // REMOVE `export const scrollListener = () => ` WHEN COPYING TO PUBLIC DIRECTORY
  // ADD TO BEGINNING OF CALL INSTEAD OF EXPORT `window.addEventListener('DOMContentLoaded', event =>`
export const scrollListener = () =>  {
    console.log("scrollListener ACTIVE");
    var menuStickyCheck = function () {
        const myMenu = document.getElementById("topHeader");
        if (!myMenu) {
            return;
        }
        // TODO: use < 10 for published version
        //if (window.scrollY < 10) {
        if (window.scrollY < 90) {
            myMenu.classList.remove("topHeaderWhite");
        } else {
            myMenu.classList.add("topHeaderWhite");
        }
    };
    menuStickyCheck();
    document.addEventListener('scroll', menuStickyCheck);
};
